import { AlertTriangle, ArrowRight, MapPin } from "lucide-react";
import { fmtAvg, fmtDay, fmtMoney, onTrial, PRICE } from "../lib/api";

const LocationCard = ({ loc, onSelect }) => {
  const active = loc.subscription_status === "active";
  const trial = onTrial(loc);
  return (
    <button onClick={() => onSelect(loc.id)} data-testid={`location-card-${loc.slug}`}
      className="text-left rounded-2xl border border-slate-200/80 bg-white p-5 card-rise">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-display text-lg font-bold truncate">{loc.name}</p>
          <p className="flex items-center gap-1 text-sm text-[#4B5A54]"><MapPin className="w-3.5 h-3.5" />{loc.location || "Main location"}</p>
        </div>
        <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase ${active ? "bg-[#E3EEF3] text-[#2E6F8E]" : "bg-amber-50 text-amber-700"}`}>
          {loc.cancel_at_period_end ? `Cancels ${fmtDay(loc.cancel_at)}` : trial ? `Free trial · ends ${fmtDay(loc.trial_ends_at)}` : active ? "Active" : loc.subscription_status === "canceled" ? "Canceled" : "Not activated"}
        </span>
      </div>
      {active ? (
        <div className="mt-4 flex items-center gap-5 text-sm">
          <span><strong className="font-display text-xl">{fmtAvg(loc.stats.avg_overall)}</strong> <span className="text-[#778580]">avg</span></span>
          <span><strong className="font-display text-xl">{loc.stats.total}</strong> <span className="text-[#778580]">reviews</span></span>
          {loc.stats.flagged > 0 && <span className="inline-flex items-center gap-1 text-red-600 font-semibold"><AlertTriangle className="w-3.5 h-3.5" />{loc.stats.flagged}</span>}
        </div>
      ) : (
        <p className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#2F5D4A]">Activate for {fmtMoney(PRICE)}/mo <ArrowRight className="w-4 h-4" /></p>
      )}
    </button>
  );
};

export const LocationsOverview = ({ locations, onSelect }) => {
  const active = locations.filter((l) => l.subscription_status === "active").length;
  const trialing = locations.filter(onTrial).length;
  return (
    <section className="space-y-4" data-testid="locations-overview">
      <div className="rounded-2xl bg-[#1A2B25] text-white px-5 py-4 flex flex-wrap items-center justify-between gap-2" data-testid="billing-summary">
        <p className="text-sm text-white/70">{active} active location{active === 1 ? "" : "s"} × {fmtMoney(PRICE)}{trialing > 0 && ` · ${trialing} on free trial`}</p>
        <p className="font-display text-2xl font-extrabold">{fmtMoney(active * PRICE)}<span className="text-sm font-sans font-medium text-white/60"> / month</span></p>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {locations.map((l) => <LocationCard key={l.id} loc={l} onSelect={onSelect} />)}
      </div>
    </section>
  );
};
